export default __webpack_public_path__ + "static/dashboard-thumb-1-df3f6cce5d26ef5f5ca11287f9db57c0.webp";